// enci.core.js

'use strict';

import './enci.fontawesome.js';
import config from 'devextreme/core/config';
import 'devextreme/integration/jquery';

// Set the license key
const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjEwYjgyZjZlLWVmZTAtNGI0OS04NjFlLTcyNTdkNWI1NjNmZCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.OrcHMUjlO8ptkwKC1UfG64t7MXjXAuxXIulqo8TozePhsWdFgLd5Dg3WH/OhOnOu+yxvr/jIpvfF3Zhk6m3xPxlVgrd/BH66on7gx2NMaKPocMnRQLZRA37UhQv5aKUZ68Kfgg==';
config({ licenseKey });

// Import all modules
import * as recaptcha from './enci.recaptcha.js';
import * as utils from './enci.utils.js';
import * as bootstrap from './enci.bootstrap.js';
import * as logger from './enci.log.js';

import * as layout from './enci.pageLoader.js';
import * as mainLayout from './Layout/MainLayout.js';
import * as alternateLayout from './Layout/AlternateLayout.js';

import * as background from './enci.background.js';
// import * as banner from './enci.banner.js';
// import * as admin from './enci.admin.js';
// import * as hero from './enci.hero.js';
import * as form from './enci.form.js';
import * as carousel from './enci.carousel.js';
import * as popup from './enci.popup.js';
import * as counter from './enci.counter.js';
import * as devextreme from './enci.devextreme.js';
import * as auth from './enci.auth.js';
import * as calendar from './enci.calendar.js';
import * as htmleditor from './enci.htmleditor.js';
import * as emailtemplates from './Admin/enci.emailtemplates.js';
import { tokenManager } from './enci.tokenManager.js';
import { themeManager } from './enci.thememanager.js';
import * as isotope from './enci.isotope.js';
// import * as datatables from './enci.datatables.js';
// import * as progress from './enci.progress.js';
// import * as preloader from './enci.preloader.js';
import * as mapbox from './enci.mapbox.js';
import * as charts from './enci.charts.js';
import * as vdr from './Page/enci.vdr.js';


// Create the enci object with all modules
const enci = {
  recaptcha,
  utils,
  bootstrap,
  logger,
  layout,
  background,
  // banner,
  // admin,
  // hero,
  form,
  carousel,
  popup,
  counter,
  devextreme,
  auth,
  calendar,
  htmleditor: {
    clearEditor: htmleditor.clearEditor,
    setEditorValue: htmleditor.setEditorValue,
    getHtmlEditorValue: htmleditor.getHtmlEditorValue,
    initialize: htmleditor.initialize,
  },
  // window.enci.default.emailtemplates.manager.loadComponent
  emailtemplates: {
    loadComponent: emailtemplates.loadComponent,
    manager: emailtemplates.emailTemplatesManager,
  },
  tokenManager: {
    startTokenRefreshTimer: () => tokenManager.startTokenRefreshTimer(),
    simulateExpiration: () => tokenManager.simulateExpiration(),
    refreshToken: async () => await tokenManager.refreshToken(),
  },
  themeManager: {
    toggle: () => themeManager.toggleTheme(),
    isDark: () => themeManager.isDarkMode(),
    setDark: () => themeManager.setDarkMode(),
    setLight: () => themeManager.setLightMode(),
  },
  vdr: {
    getState: vdr.getState,
    setState: vdr.setState,
    clearState: vdr.clearState,
    clearAllStates: vdr.clearAllStates,
    manager: vdr.vdrManager,
  },
  alternateLayout: {
    initializeComponent: alternateLayout.initializeComponent,
    cleanupComponent: alternateLayout.cleanupComponent,
    initializeThemeRoute: alternateLayout.initializeThemeRoute,
    manager: alternateLayout.alternateLayoutManager,
  },
  mainLayout: {
    initializeComponent: mainLayout.initializeComponent,
    cleanupComponent: mainLayout.cleanupComponent,
    initializeThemeRoute: mainLayout.initializeThemeRoute,
    manager: mainLayout.mainLayoutManager,
  },
  isotope,
  // datatables,
  // progress,
  // preloader,
    mapbox,
    charts
};

// Initialize theme manager
themeManager.init().catch(console.error);

// Expose enci globally
if (typeof window !== 'undefined') {
  window.enci = { default: enci };
}

export default enci;
